import React from "react";
import {
  BannerWrapper,
  BannerMessage,
  UpgradeButton,
} from "./trialEndingBannerStyles";

/**
 * Banner shown when trial is ending soon.
 * Design from Figma: gradient background, message text, "Upgrade Now" CTA.
 * This is a purely presentational component - all logic is handled by parent.
 */
const TrialEndingBanner = ({
  displayMessage,
  showButton = true,
  onUpgradeClick,
  upgradeLabel = "Upgrade Now",
  className,
}) => {
  return (
    <BannerWrapper className={className}>
      <BannerMessage>{displayMessage}</BannerMessage>
      {showButton && (
        <UpgradeButton type="button" onClick={onUpgradeClick}>
          {upgradeLabel}
        </UpgradeButton>
      )}
    </BannerWrapper>
  );
};

export default TrialEndingBanner;
